<template>
  <div>
    <NavBar />
    <NavBarSecond
      :pageType="'components.secondNavBar.logiciel' | i18n"
      :backRoute="getBackRoute()"
    />
    <b-row no-gutters id="details-main" class="mx-auto mt-5">
      <b-col xs="12" xl="4">
        <!--Le nom du logiciel-->
        <div
          id="software-name"
          class="bg-primary d-flex shadow-sm rounded px-5 py-4 text-white mb-4 align-items-left flex-column "
        >
          <h3 class="m-0 text-break pb-2">{{ software.nom_application }}</h3>
          <span class="pb-2"
            ><i class="icon user circle" />{{ softwareOwner }}</span
          >
          <span><i class="icon server" />{{ softwareServer.nom }}</span>
        </div>
        <!--Les informations du logiciel-->
        <div id="software-details" class="bg-white shadow-sm rounded p-5 mb-4">
          <DetailsSoftwareSection :softwareId="softwareId" />
        </div>
        <!-- Seuils du logiciel -->
        <div id="software-thresholds" class="bg-white shadow-sm rounded p-5">
          <ListThresholdsSection :id="softwareId" />
        </div>
        <!-- Statistiques des erreurs captées dans un tableau -->
      </b-col>

      <b-col xs="12" xl="8" class="pl-xl-4 pt-4 pt-xl-0">
        <!-- Historique des états du logiciel -->
        <div
          id="software-errors"
          class="bg-white shadow-sm rounded p-5 mb-4 position-relative"
        >
          <!-- softwareid -->
          <ChartErrorsBySoftware :softwareId="softwareId" />
        </div>
        <div id="software-logs" class="bg-white shadow-sm rounded p-5">
          <ListBalanceStateSection :softwareId="softwareId" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  DetailsSoftwareSection,
  ListBalanceStateSection,
  ListThresholdsSection
} from "@/sections";

import { ChartErrorsBySoftware, NavBar, NavBarSecond } from "@/components";

/**
 * @description Page de détails d'un logiciel
 * @author Samuel Colassin
 * @author Alexandre Gallant
 * @author Francine Jin
 * @vue-data {Object} software - Les informations du logiciel
 * @vue-data {String} softwareId - L'id du logiciel
 * @vue-data {String} softwareOwner - Le nom du client
 * @vue-data {Object} softwareServer - Les informations du serveur du logiciel
 */
export default {
  components: {
    DetailsSoftwareSection,
    ChartErrorsBySoftware,
    ListBalanceStateSection,
    ListThresholdsSection,
    NavBar,
    NavBarSecond
  },
  data() {
    return {
      software: {},
      softwareId: this.$route.params.id,
      softwareOwner: "",
      softwareServer: {}
    };
  },
  /**
   * @description Fait une requête pour obtenir les informations essentielles dans la page
   */
  beforeMount() {
    this.getData();
  },
  methods: {
    /**
     * @description Fait une requête pour obtenir le nom, le possesseur et le serveur du logiciel
     */
    async getData() {
      try {
        await this.getSoftware();
        await this.getServer();
        await this.getClientName();
      } catch (e) {
        //il faudra définir les types d'erreur et les redirections en conséquence
        this.$router.push("/404");
      }
    },
    /**
     * @description Fait une requête pour obtenir les informations du logiciel
     */
    async getSoftware() {
      await this.$api
        .getSoftware(this.$route.params.id)
        .then(res => {
          this.software = res.data.data;
        })
        .catch();
    },
    /**
     * @description Fait une requête pour obtenir les informations du serveur du logiciel
     */
    async getServer() {
      await this.$api
        .getServer(this.software.serveur_id)
        .then(res => {
          this.softwareServer = res.data.data;
        })
        .catch();
    },
    /**
     * @description Fait une requête pour obtenir le nom du client du logiciel
     */
    async getClientName() {
      await this.$api
        .getClient(this.softwareServer.client_id)
        .then(res => {
          this.softwareOwner = res.data.data.nom;
        })
        .catch();
    },
    /**
     * @description Méthode qui donne la bonne route de redirection pour le retour
     */
    getBackRoute() {
      return this.$user.get().role == "admin" ? "/admin" : "/dashboard";
    }
  }
};
</script>
<style scoped lang="scss">
@media screen and (min-width: 1366px) {
  #details-main {
    width: 1366px;
  }
}
</style>
